import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ReactionsPublicAPI} from '@wix/document-services-public-types'
import {reactions, utils} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<ReactionsPublicAPI> {
    return {
        methods: {
            components: {
                reactions: {
                    add: publicMethodUtils.defineDataManipulationAction(reactions.addWithRef, {
                        isUpdatingAnchors: utils.DONT_CARE,
                        getReturnValue: reactions.getReactionsRef
                    }),
                    update: publicMethodUtils.defineDataManipulationAction(reactions.update),
                    disable: publicMethodUtils.defineDataManipulationAction(reactions.disable),
                    get: publicMethodUtils.defineGetter(reactions.get),
                    getByTrigger: publicMethodUtils.defineGetter(reactions.getByTrigger),
                    removeAll: publicMethodUtils.defineGetter(reactions.removeAll),
                    remove: publicMethodUtils.defineGetter(reactions.remove)
                }
            }
        }
    }
}
